import React from 'react';

import { ICellRendererParams } from 'ag-grid-community';

export const CheckmarkValueRenderer = ({
  value,
}: ICellRendererParams): React.ReactElement => {
  return <span className="custom-cell__checkmark">{value ? '✓' : ''}</span>;
};
